import clsx from "clsx";

import { FCCC } from "@/types";

export const ContentContainer: FCCC = ({ children, className }) => (
  <div className={clsx("grid-container p-4 tablet:p-6 desktop:p-8", className)}>
    <div className="grid grid-cols-grid gap-x-gutter">{children}</div>
  </div>
);
